import { fetchRoleAll } from '@/api/role';
import types from '../types';

const state = {
  roles: [],
};

const mutations = {
  [types.SET_ROLES](state, roles) {
    state.roles = roles;
  }
};

const actions = {
  getResources({ commit }) {
    this.tableLoading = true;
    return fetchRoleAll()
      .then(res => {
        const roles = res.data.data || [];
        commit(types.SET_ROLES, roles);
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/role.js